import { createAction } from 'redux-actions';

export const CREATE_TOAST = 'CREATE_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

export const createToast = createAction(CREATE_TOAST);
export const removeToast = createAction(REMOVE_TOAST);
